module.exports = __webpack_public_path__ + "static/media/noimage.ce45efbf.png";